import { Component, OnInit , Inject} from '@angular/core';
import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { VoucherService } from "../../../../accounts/voucher/shared/voucher.service";
import { PrintcashbookService } from "../../print/printcashbook.service";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LedgerService } from "../../../../master/ledger/shared/ledger.service";
import { debounceTime } from "rxjs/operators";
import { ToasterserviceService } from "../../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../../utility/shared/toastpayload";

@Component({
  selector: 'app-rptcashbookpopup',
  templateUrl: './rptcashbookpopup.component.html',
  styleUrls: ['./rptcashbookpopup.component.css']
})
export class RptcashbookpopupComponent implements OnInit {

  BranchList: any[] = [];
  toast : Toastpayload;

  constructor(private commonmastersService: CommonmastersService,
    private printcashbookService: PrintcashbookService,
    private ledgerService: LedgerService,
    private voucherService: VoucherService ,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RptcashbookpopupComponent>,
    private toasterserviceService: ToasterserviceService,) { }

  ngOnInit() {
    this.GetBranchList(); 
    // this.data.BranchId = 0;
    this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  }

  GetBranchList() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  GenerateReports(): void {
    this.data.ReportName = "CashbookReport";    
    this.printcashbookService.GenerateReport(this.data);
    this.dialogRef.close();

     // toastr Notification
     this.toast = {
      message: "Please wait, the report is loading in the new tab!",
      title: 'Report', 
      ic:  {
        timeOut: 5000,
        closeButton: true,
      } as IndividualConfig,
      type: 'info',    
    };

    // this.toast.type = 'info';
    this.toasterserviceService.showToast(this.toast);
  }

}
